import { QRCodeModule } from 'angularx-qrcode';
import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnFormInputModule } from '@lib/form/input';
import { SnFormMobilePhoneModule } from '@lib/form/mobile-phone';
import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnSearchbarModule } from '@lib/ui/searchbar';
import { SnAlertModule } from 'libs/ui/alert/src/lib/alert.module';

import { SnAccountRouting } from './account.routing';
import {
  SnChangeNameDialogComponent,
  SnChangeBadgeDialogComponent,
  SnChangeEmailDialogComponent,
  SnChangePhoneDialogComponent,
  SnChangeTitleDialogComponent,
  SnChangePasswordDialogComponent,
  TwoFactorAuthenticationDialogComponent,
  ManageMfaDialogComponent,
  MfaBackupCodesDialogComponent,
  MfaListDialogComponent,
  MfaTableComponent,
  MfaVerificationDialogComponent,
} from './components';
import { SnAccountSettingsContainer } from './containers';

@NgModule({
  imports: [
    CommonModule,
    SnCommonModule,
    ReactiveFormsModule,
    FormsModule,

    // Material
    MatInputModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatStepperModule,
    MatButtonModule,
    MatListModule,
    MatDividerModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
    NgxLoadingButtonsModule,
    MatTooltipModule,
    MatProgressBarModule,

    // Libs
    SnButtonModule,
    SnIconModule,
    SnListModule,
    SnFormModule,
    SnFormInputModule,
    SnFormMobilePhoneModule,
    SnAlertModule,
    QRCodeModule,
    ClipboardModule,
    SnSearchbarModule,
    SnActionsModule,
    SnDataListModule,
    // i18n
    TranslationModule,
    // Routing
    SnAccountRouting,
  ],
  declarations: [
    // Dialogs
    SnChangeNameDialogComponent,
    SnChangeBadgeDialogComponent,
    SnChangeEmailDialogComponent,
    SnChangePhoneDialogComponent,
    SnChangeTitleDialogComponent,
    SnChangePasswordDialogComponent,
    TwoFactorAuthenticationDialogComponent,
    ManageMfaDialogComponent,
    MfaListDialogComponent,
    MfaTableComponent,
    MfaBackupCodesDialogComponent,
    MfaVerificationDialogComponent,

    // Pages
    SnAccountSettingsContainer,
  ],
  exports: [
    SnChangePasswordDialogComponent,
  ],
})
export class SnAccountModule {}
